import { ItemPageSellerBadgesInfoDto } from 'types/dtos/item-page-seller-badges'

import { ItemPageSellerBadgesInfoPluginModel } from './types'

export const getItemPageSellerBadgesInfoPluginModel = (
  sellerBadgesInfoDto: ItemPageSellerBadgesInfoDto,
): ItemPageSellerBadgesInfoPluginModel => {
  return sellerBadgesInfoDto
}
